/**
 * @generated SignedSource<<5c301c9c39b0c1b59fe2f17338ba5af0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobStatusEnum = "FAILURE" | "PENDING" | "RETRY" | "RUNNING" | "SUCCESS" | "%future added value";
export type InternBrandJobsRefetchQuery$variables = {
  brandId: string;
  limit: number;
  offset: number;
  status?: JobStatusEnum | null;
  taskName?: string | null;
};
export type InternBrandJobsRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"InternBrandJobs_jobs">;
};
export type InternBrandJobsRefetchQuery = {
  response: InternBrandJobsRefetchQuery$data;
  variables: InternBrandJobsRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "limit"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offset"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskName"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "brandId",
    "variableName": "brandId"
  },
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status"
  },
  {
    "kind": "Variable",
    "name": "taskName",
    "variableName": "taskName"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternBrandJobsRefetchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "InternBrandJobs_jobs"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternBrandJobsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "JobsConnection",
        "kind": "LinkedField",
        "name": "internJobs",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JobType",
            "kind": "LinkedField",
            "name": "jobs",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taskId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taskName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "brandId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "brandName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "completedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "durationMs",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "inputArgs",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resultData",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "errorMessage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "traceback",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "retryCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "worker",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasNextPage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasPreviousPage",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7f3b1be6151d7dc7c44d84e37cd37cf5",
    "id": null,
    "metadata": {},
    "name": "InternBrandJobsRefetchQuery",
    "operationKind": "query",
    "text": "query InternBrandJobsRefetchQuery(\n  $brandId: String!\n  $limit: Int!\n  $offset: Int!\n  $status: JobStatusEnum\n  $taskName: String\n) {\n  ...InternBrandJobs_jobs_18e8YR\n}\n\nfragment InternBrandJobs_jobs_18e8YR on Query {\n  internJobs(brandId: $brandId, status: $status, taskName: $taskName, limit: $limit, offset: $offset) {\n    jobs {\n      id\n      taskId\n      taskName\n      status\n      brandId\n      brandName\n      startedAt\n      completedAt\n      durationMs\n      inputArgs\n      resultData\n      errorMessage\n      traceback\n      retryCount\n      worker\n      createdAt\n    }\n    totalCount\n    hasNextPage\n    hasPreviousPage\n  }\n}\n"
  }
};
})();

(node as any).hash = "a5f909011e1660e783d4f67795cc700b";

export default node;
